var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.1C4 1.80826 4.10536 1.52847 4.29289 1.32218C4.48043 1.11589 4.73478 1 5 1H15L20 6.5V21.9C20 22.1917 19.8946 22.4715 19.7071 22.6778C19.5196 22.8841 19.2652 23 19 23H5C4.73478 23 4.48043 22.8841 4.29289 22.6778C4.10536 22.4715 4 22.1917 4 21.9V2.1Z",
    stroke: "#C6CBD9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.80005H16M8 14.2H16",
    stroke: "#C6CBD9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.80b7819b649e30fbad5feb428df28123.svg";
export { ForwardRef as ReactComponent };